import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ConfirmDialogService } from './confirm-dialog.service';

export interface ConfiguratorComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;

    // Le guard ne manipule pas lui-même le payload : il le transmet tel quel
    // à la modale de confirmation. Certains configurateurs utilisent `void`,
    // d'autres transportent `{ ref, nextUrl }` pour "sauver et quitter".
    saveSubject: Subject<any>;
  changesSubject: BehaviorSubject<boolean>;
  isCompleteSubject: BehaviorSubject<boolean>;
}

@Injectable()
export class ConfiguratorPendingChangesGuard implements CanDeactivate<ConfiguratorComponentCanDeactivate> {

    constructor(
        private confirmDialogService: ConfirmDialogService,
    ) {

    }

    canDeactivate(
        component: ConfiguratorComponentCanDeactivate,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): boolean | Observable<boolean> {
        // if there are no pending changes, just allow deactivation; else confirm first
        const res = component.canDeactivate();
        const changesSubject = component.changesSubject;
        const saveSubject = component.saveSubject;
        const isCompleteSubject = component.isCompleteSubject;
        if (res === true) return res;


        // return false;
        return (this.confirmDialogService.openConfirmationModal({
            nextUrl: nextState.url,
            changesSubject,
            saveSubject,
            isCompleteSubject
        }), false);
    }
}
